export default "__VITE_ASSET__DXHfphiR__"